import { BaseEditViewStore} from 'core/stores';
import { FacilityOrderNewFlowUSIntakePatientNoteEditModalForm } from 'application/facility-order-new-flow-us-intake/forms';
import { FacilityOrderPatientService } from "application/facility-order-new-flow-insurance/services";
import { action } from "mobx";

class FacilityOrderNewFlowUSIntakePatientNoteEditModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const facilityOrderPatientService = new FacilityOrderPatientService(rootStore.application.baasic.apiClient);
        const facilityOrderPatient = componentProps.modalParams.data.facilityOrderPatient;
        super(rootStore, {
            name: 'facility-order-patient-add-note-modal',
            Form: FacilityOrderNewFlowUSIntakePatientNoteEditModalForm,
            id: facilityOrderPatient.id,
            actions: () => {
                return {
                    get: async() =>{
                        return facilityOrderPatient;
                    },
                    update: async (resource) => {
                        const response = await facilityOrderPatientService.updateNote({ ...resource});
                        return response.data;
                    },
                }
            },
            FormClass: FacilityOrderNewFlowUSIntakePatientNoteEditModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.refreshNote = this.modalParams.data.refreshNote;
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                id: this.id,
                ...resource
            });

            this.form.setFieldsDisabled(false);
            await this.refreshNote(resource.note);
            this.modalParams.close();
            await setTimeout(() => this.notifySuccessUpdate(this.name), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('FACILITY_ORDER_NEW_FLOW.EDIT.PATIENT_NOTE.SUCCESS_UPDATE', name);
    }
}

export default FacilityOrderNewFlowUSIntakePatientNoteEditModalStore;
